<template>
  <div class="ticket-id-display flex items-center justify-between">
    <img 
      src="https://img.mfrcdn.com/static/images/v/174be7b52da8b0fdc1471140261de395.png" 
      alt="Ticket"
      class="ticket-icon"
    />
    <span 
      class="ticket-label cursor-pointer" 
      @click="copyToClipboard()"
    >Conversation ID:</span>
    <span 
      class="ticket-value cursor-pointer" 
      @click="copyToClipboard()"
    >{{ conversationId }}</span>
  </div>
</template>

<script>
import { useAlert } from 'dashboard/composables';

export default {
  name: 'TicketIdDisplay',
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.conversationId.toString())
        .then(() => {
          useAlert('Conversation ID has been copied to clipboard');
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
        });
    }
  }
};
</script>

<style scoped>
.ticket-id-display {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px;
  height: 32px;
  border-radius: 4px;
  background-color: var(--color-background-light);
  margin-right: 8px;
}

.ticket-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.ticket-label {
  color: #161616;
  font-size: 12px;
  font-weight: 600;
}

.ticket-value {
  color: #161616;
  font-size: 12px;
  font-weight: 600;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  opacity: 0.8;
}
</style>
